import gql from "graphql-tag";

export const getBaseEDCSubject = gql`query getBaseEDCSubject($subjectId: String) {
  baseEDCSubject(subjectId: $subjectId) {
    birthYear
    gender
    startDate
  }
}`;

export const createPatient = gql`mutation createPatient($subjectId: String)
{
  createUpdatePatient(subjectId: $subjectId) {
    user {
      patientId
    }
  }
}`
